module.exports = __webpack_public_path__ + "images/carousel-arrow-prev.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/carousel-arrow-prev.png
// module id = 847
// module chunks = 0